import { PercentPipe } from '@angular/common';
import { Component, Injector, Input, OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatFormFieldControl } from '@angular/material';
import { AbstractMatFormFieldControl } from '@mctic/ng-core';
import { Subscription } from 'rxjs';
import { startWith, pairwise } from 'rxjs/operators';

@Component({
  selector: 'app-percent',
  providers: [
    {provide: MatFormFieldControl, useExisting: PercentComponent},
    PercentPipe
  ],
  template: `
    <input
      matInput
      [mask]="mask"
      placeholder="0,0"
      [formControl]="percentControl"
      [dropSpecialCharacters]="false"
      [maxLength]="maxlength"
      [ngClass]="{'text-right': align === 'right', 'text-left': align === 'left'}"
    >
  `
})
export class PercentComponent extends AbstractMatFormFieldControl<number> implements OnInit, OnDestroy {

  @Input() maxlength = '7';
  @Input() allowNegative = false;
  @Input() align: 'right' | 'left' = 'right';
  @Input() mask: string = '0,0999'
  @Input() maxDecimalCases = 1;

  percentControl: FormControl;

  private readonly subscriptions: Subscription[] = [];

  constructor(injector: Injector) {
    super(injector);
  }

  ngOnInit(): void {
    this.percentControl = new FormControl();
    this.percentControl.setValidators(this.formControl.validator);

    if (this.formControl.value && this.formControl.value.length) {
      this.percentControl.setValue(this.formControl.value.toString().replace('.', ''));
    }

    this.subscriptions.push(this.percentControl.valueChanges
      .pipe(startWith(null as string), pairwise())
  .subscribe(([prev, next]: [any, any]) => this.handlerPercentChange(next, prev) ))


    this.subscriptions.push(this.formControl.statusChanges.subscribe(() => this.handleFormControlStatusChange()));
    this.subscriptions.push(this.formControl.valueChanges.subscribe((value: number) => this.handleFormControlChange(value)));

    this.handleFormControlStatusChange();
  }

  private handlerPercentChange(valor: string, valorAnterior: string) {

    if(valor && valor != valorAnterior && this.isValorValido(valor, valorAnterior)) {
      let valueFormat = valor.replace(',', '.');
      this.formControl.setValue(Number(valueFormat))
    }
  }

  isValorValido(valor: string, valorAnterior: string):boolean {
    if(valorAnterior && valor) {
      let valorFormatado = valor.replace(',','')
      let valorAnteriorFormatado = valorAnterior.slice(1);
      valorAnteriorFormatado = valorAnteriorFormatado.replace(',','')
      return  valorFormatado !== valorAnteriorFormatado;
    }
    return true
  }

  private handleFormControlChange(value: number) {
    let percent = null;

    if (value !== null) {
      const valueString = value.toString();

      if (valueString && valueString.length) {
        percent = valueString.replace('.', '');
      }
    }

    if (percent !== this.percentControl.value) {
      this.percentControl.setValue(percent);
    }
  }

  private handleFormControlStatusChange() {
    if (this.formControl.disabled) {
      this.percentControl.disable({emitEvent: false});
    } else {
      this.percentControl.enable({emitEvent: false});
    }
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(o => o.unsubscribe());
  }
}
